import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import css from './EditListingFeaturesForm.module.css';
import 'react-dates/initialize';
import '../../../../styles/reactDatesPicker.css';

const DatePickerField = ({
  input,
  meta,
  label,
  placeholder = 'Pick a date...',
  form,
  formValues = {},
  fieldName = 'lastInspection',
}) => {
  const [focused, setFocused] = useState(false);
  const [date, setDate] = useState(null);

  useEffect(() => {
    // Initialize local date state from formValues
    const fieldVal = formValues?.[fieldName];
    if (typeof fieldVal === 'number') {
      setDate(moment.unix(fieldVal));
    } else if (moment.isMoment(fieldVal)) {
      setDate(fieldVal);
    } else if (typeof fieldVal === 'string') {
      setDate(moment(fieldVal));
    } else {
      setDate(moment()); // Default to today
    }
  }, [formValues, fieldName]);

  const handleDateChange = newDate => {
    if (newDate?.isValid()) {
      setDate(newDate);
      form?.change(fieldName, newDate.unix());
      input.onChange(newDate.unix());
    } else {
      setDate(null);
      form?.change(fieldName, null);
      input.onChange(null);
    }
  };

  const isOutsideRange = day => day.isAfter(moment(), 'day');


  return (
    <div className={css.datePickerWrapper}>
      <label className={css.label}>{label}</label>
      <SingleDatePicker
        id={fieldName}
        date={date}
        onDateChange={handleDateChange}
        focused={focused}
        onFocusChange={({ focused }) => setFocused(focused)}
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        isOutsideRange={isOutsideRange}
        displayFormat="MMM D, YYYY"
        placeholder={placeholder}
        readOnly
        small
      />
      {meta?.touched && meta?.error && <div className={css.error}>{meta.error}</div>}
    </div>
  );
};

export default DatePickerField;
